// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker with enhanced logging and support
serviceWorkerRegistration.register({
  onSuccess: () => console.log('Service Worker registered successfully.'),
  onUpdate: (registration) => {
    console.log('New content available. Refresh the page to update.');
    if (registration?.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  },
  onError: (error) => console.error('Service Worker registration failed:', error),
});

// Log web vitals
reportWebVitals(console.log);